<template>
  <div>
    <div class="load">
      <input v-model="ref" type="text" placeholder="ref..." />
      <button class="bouton" @click.prevent="loadRef">Charger</button>
    </div>
    <div v-if="user" class="userLink">
      <router-link :to="{ path: '/v3/admin/users', query: { id: user.idProfile } }"
        >{{ user.pseudo }} ({{ user.email || user.oldEmail }})</router-link
      >
    </div>
    <div class="tables">
      <table class="results dataTable" v-if="sales.length && !selectedSales">
        <tr
          :class="{ selected: sal == selectedSales }"
          v-for="sal of sales"
          :key="sal.id"
          class="content"
          @click="selectSales(sal)"
        >
          <td>{{ sal.ref }} ({{ sal.occurence }})</td>
          <td>{{ formatDate(sal.date) }}</td>
          <td><span v-html="idyuSalesStatus(sal.status)"></span>({{ sal.status }})</td>
        </tr>
      </table>

      <table class="details dataTable" v-if="selectedSales && user">
        <tr>
          <td>Ref</td>
          <td>{{ selectedSales.ref }} ({{ selectedSales.occurence }})</td>
        </tr>
        <tr>
          <td>Status</td>
          <td><span v-html="idyuSalesStatus(selectedSales.status)"></span>({{ selectedSales.status }})</td>
        </tr>
        <tr>
          <td>Date</td>
          <td>{{ formatDate(selectedSales.date) }}</td>
        </tr>
        <tr>
          <td>Pseudo</td>
          <td>{{ user.pseudo }}</td>
        </tr>
        <tr>
          <td>Email</td>
          <td>
            <span v-if="user.email">{{ user.email }}</span
            ><span v-else class="old">{{ user.oldEmail }}</span>
          </td>
        </tr>
        <tr>
          <td>Produit</td>
          <td>{{ selectedSales.product.name }}</td>
        </tr>
        <tr>
          <td>Moyen Paiement</td>
          <td>{{ selectedSales.paymentMethod.name }}</td>
        </tr>
        <tr>
          <td>Pass en cours</td>
          <td v-html="user.pass.name"></td>
        </tr>
        <tr>
          <td>Expiration</td>
          <td>{{ formatDate(user.pass.expiration) }}</td>
        </tr>
        <tr>
          <td>Supprime</td>
          <td :class="{ red: user.deleted }">{{ user.deleted }}</td>
        </tr>
      </table>

      <div v-else></div>
      <div class="boutonsSales" v-if="selectedSales">
        <button class="bouton" @click="valider" :disabled="selectedSales.status != 0">Valider</button>
        <button
          class="bouton"
          @click="annuler"
          v-if="selectedSales.status != 0 && selectedSales.paymentMethod.type <= 2"
        >
          Annuler
        </button>
        <button
          class="bouton"
          @click="rembourser"
          v-if="selectedSales.paymentMethod.type == 5"
          :disabled="selectedSales.status != 2"
        >
          Rembourser
        </button>
        <button class="bouton" @click="impaye">Impayé</button>
        <button class="bouton" @click="cancelRec" :disabled="user.pass.status != 11">Annuler le renouvellement</button>
        <button class="bouton" @click="selectedSales = null">Fermer ce paiement</button>
      </div>
    </div>
  </div>
</template>

<script>
import { idyuJsonRpc } from "@/assets/js/idyu/connect.js";
import { idyuFormatDate } from "@/assets/js/idyu/util";
import { idyuSalesStatus } from "@/assets/js/idyu/reference";

export default {
  data() {
    return {
      ref: "",
      sales: [],
      selectedSales: null,
      user: null
    };
  },

  methods: {
    idyuSalesStatus: idyuSalesStatus,
    async reload() {
      const idSelected = this.selectedSales.id;
      this.ref = this.selectedSales.ref;
      await this.loadRef();
      await this.selectSales(this.sales.find(elt => elt.id === idSelected));
    },

    async loadRef(ref = null) {
      if (ref) {
        this.ref = ref;
      }
      if (this.ref.length) {
        this.selectedSales = null;
        this.user = null;
        this.sales = await idyuJsonRpc("getPaymentInfoAllOccurences", this.ref);
        this.sales.sort((a, b) => {
          if (a.occurence < b.occurence) {
            return -1;
          }
          return 1;
        });
        if (this.sales.length) {
          this.user = await idyuJsonRpc("getUserById", this.sales[0].idUser);
        }
      }
    },

    async impaye() {
      await idyuJsonRpc("impaye", this.selectedSales.id);
      this.reload();
    },

    async valider() {
      await idyuJsonRpc("validCheckPayment", this.selectedSales.id);
      this.reload();
    },

    async annuler() {
      await idyuJsonRpc("cancelPayment", this.selectedSales.id);
      this.reload();
    },

    async cancelRec() {
      await idyuJsonRpc("cancelRecurring", this.selectedSales.id);
      this.reload();
    },

    async rembourser() {
      await idyuJsonRpc("recreditSale", this.selectedSales.id);
      this.reload();
    },

    async selectSales(sal) {
      this.selectedSales = sal;
    },

    formatDate(date) {
      return idyuFormatDate(date);
    }
  }
};
</script>

<style scoped lang="scss">
.load {
  margin-top: 10px;
  display: grid;
  grid-auto-flow: column;
  grid-gap: 10px;
  grid-template-columns: 1fr 150px;
}

.dataTable {
  tr:nth-child(odd) td {
    background-color: rgba(0, 0, 0, 0.1);
  }
  tr.content:hover {
    background-color: rgba(221, 187, 92, 0.2);
  }
  td {
    cursor: pointer;
  }
}

.details {
  td:first-child {
    width: 150px;
  }
  td:nth-child(2) {
    font-weight: bold;
  }
}

.tables {
  margin-top: 10px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  align-items: start;
}

.selected {
  background-color: rgba(221, 187, 92, 0.2);
}

.boutonsSales {
  display: grid;
  grid-gap: 5px;
}

.red {
  color: red;
}

.old {
  color: gray;
  font-style: italic;
}

.userLink {
  margin-top: 10px;
  a {
    color: blue;
    text-decoration: underline;
  }
}
</style>
